import React, { useCallback } from 'react'
import styled from 'styled-components'
import { stopPropagation } from '../../../utils/func'

const SPopoverIcon = styled.div`
  position: relative;
  left: 35px;
  display: inline-block;
  width: 14px;
  height: 14px;
  line-height: 14px;
  font-size: 12px;
  color: #fff;
  border-radius: 50%;
  background-color:#D6A485;
  cursor:pointer;
  text-align: center;
`;

export default function Mark() {
  const jump = useCallback( async(event) => {
    stopPropagation(event)
    window.open('https://bakeryswap.medium.com/introducing-bakery-nft-artworks-voting-features-992f7a66741', 'target')
  }, [])
  return (
    <>
      <SPopoverIcon onClick={jump}>
        ?
      </SPopoverIcon>
    </>
  );
};